/*
Controller: Users

Operations:
  setDefaultFoundryForUser
  getUserFoundries
  getFoundries
  setSessionFoundryForUser
  getAllUserFoundries
  getFoundrySupportUsers
  sendEmailVerification
*/
var Api = require('../config')
var FoundryDetailsDef = require('../definitions/FoundryDetails')

var Users = (function () {
  /*
  Operation: setDefaultFoundryForUser
  Set default foundry for the foundry user
  Parameters:

  Responses:
    HTTP 200: Successful Operation
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function setDefaultFoundryForUserUsers (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        FoundryDetailsDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/defaultFoundry'
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getUserFoundries
  Get list of foundries for the user
  Parameters:
  Responses:
    HTTP 200: Successful Operation
    HTTP 401: Unauthorized
    HTTP 424: The requested resource depends on another resource that has failed.
  */
  function getUserFoundriesUsers () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/foundries'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFoundries
  Search foundries from PIM
  Parameters:
    name: Tag name
  Responses:
    HTTP 200: Successful Operation
    HTTP 401: Unauthorized
  */
  function getFoundriesUsers (name) {
    return new Promise(function (resolve, reject) {
      try {
        if (!name) {
          throw new Error('name: Missing parameter')
        }
        if (name && !(typeof name === 'string')) {
          throw new Error('name: Wrong type: Got "' + (typeof name) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['name'] = name
      var path = '/foundries/support/allFoundries'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: setSessionFoundryForUser
  Set session foundry for the foundry user
  Parameters:

  Responses:
    HTTP 200: Successful Operation
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function setSessionFoundryForUserUsers (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        FoundryDetailsDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/sessionFoundry'
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getAllUserFoundries
  Get all associated foundries of logged in user
  Parameters:
    module: Module used to filter foundries by permission.
agreements → agreements permission; foundryProfile → foundry profile permission.
Defaults to agreements when omitted or invalid.

  Responses:
    HTTP 200: Collection of Contacts
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
    HTTP 424: The requested resource depends on another resource that has failed.
  */
  function getAllUserFoundriesUsers (module) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['module'] = module
      var path = '/users/foundries'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFoundrySupportUsers
  Get contact data for all foundry support users
  Parameters:
  Responses:
    HTTP 200: Collection of Contacts
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getFoundrySupportUsersUsers () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/users/foundrySupport'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: sendEmailVerification
  Send verification email to the current user
  Parameters:
  Responses:
    HTTP 200: Verification email job accepted; Auth0 will email the authenticated user.
    HTTP 400: Invalid request.
    HTTP 401: Missing or invalid session token.
    HTTP 500: Internal server error.
  */
  function sendEmailVerificationUsers () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/users/sendEmailVerification'
      Api
        .request({
          url: path,
          method: 'post'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['setDefaultFoundryForUser'] = setDefaultFoundryForUserUsers
  ret['getUserFoundries'] = getUserFoundriesUsers
  ret['getFoundries'] = getFoundriesUsers
  ret['setSessionFoundryForUser'] = setSessionFoundryForUserUsers
  ret['getAllUserFoundries'] = getAllUserFoundriesUsers
  ret['getFoundrySupportUsers'] = getFoundrySupportUsersUsers
  ret['sendEmailVerification'] = sendEmailVerificationUsers
  return ret
})()

module.exports = Users
